import moment from "moment/moment";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getIncidentType,
  insertIncident,
  updateInformation,
} from "../../redux/actionCreator";
import {
  incident_details,
  incident_type_details,
  ip_address,
  otp_id,
  submitLoader,
  updateRedux,
} from "../../redux/commonReducer";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function Page4({ inputs, setStage, setInputs }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const lang = localStorage.getItem("lang");
  const navigate = useNavigate();

  const [modalshow, setModalShow] = useState(false);
  const [fileView, setFileView] = useState(null);
  const [loader, setLoader] = useState(false);

  const incident_type_list = useSelector(incident_type_details);
  const otpId = useSelector(otp_id);
  const details = useSelector(incident_details);
  const submitLoad = useSelector(submitLoader);
  const ipAddress = useSelector(ip_address);

  const [disableButtons, setDisabledButtons] = useState([]);

  const addToDisabled = (btn) => {
    setDisabledButtons([...disableButtons, btn]);
  };

  const removeFromDisabled = (btn) => {
    setDisabledButtons(disableButtons?.filter((e) => e != btn));
  };

  useEffect(() => {
    dispatch(getIncidentType());
    dispatch(updateRedux({ key: "submitLoader", value: false }));
  }, []);

  const onSubmitHandler = () => {
    setLoader(true);
    addToDisabled("submitButton");
    let formData = new FormData();
    formData.append("first_name", inputs.first_name);
    formData.append("last_name", inputs.last_name);
    formData.append("phone", inputs.phone_number);
    formData.append("email", inputs.email);
    formData.append('emirates_id', inputs.emirates_id,)
    // formData.append('emirates_id_proof', inputs.emirates_id_proof[0])
    formData.append("incident_type", inputs.incident_type._id);
    formData.append("incident_description", inputs.description);
    formData.append(
      "incident_date",
      inputs.date ? moment(inputs?.date).format("MM-DD-YYYY") : ""
    );
    formData.append(
      "is_reported_elsewhere",
      inputs.reported_elsewhere == "Yes" ? 1 : 0
    );
    formData.append("incident_entity", inputs.entity);
    formData.append("id", details._id);
    inputs.files?.forEach((item, i) => {
      formData.append(`incident_attachment`, item)
    });
    formData.append("language", localStorage.getItem("lang"));
    // formData.append("os", window?.navigator?.oscpu);
    // console.log(window?.navigator?.oscpu, window?.navigator?.appVersion);
    if (window?.navigator?.appVersion.indexOf("Win") != -1) {
      formData.append("os", "Windows");
    } else if (window?.navigator?.appVersion.indexOf("Mac") != -1) {
      formData.append("os", "MacOS");
    } else if (window?.navigator?.appVersion.indexOf("X11") != -1) {
      formData.append("os", "UNIX");
    } else if (window?.navigator?.userAgent.indexOf("Android") != -1) {
      formData.append("os", "Android");
    } else if (window?.navigator?.appVersion.indexOf("Linux") != -1) {
      formData.append("os", "Linux");
    }
    // if (window?.navigator?.userAgent.indexOf("Win") != -1) formData.append("os", "Windows");
    // if (window?.navigator?.userAgent.indexOf("Mac") != -1) formData.append("os", "Macintosh");
    // if (window?.navigator?.userAgent.indexOf("Linux") != -1) formData.append("os", "Linux");
    // if (window?.navigator?.userAgent.indexOf("Android") != -1) formData.append("os", "Android");
    // if (window?.navigator?.userAgent.indexOf("like Mac") != -1) formData.append("os", "iOS");
    // formData.append("browser", window?.navigator?.appCodeName);
    if (
      (navigator.userAgent.indexOf("Opera") ||
        navigator.userAgent.indexOf("OPR")) != -1
    ) {
      formData.append("browser", "Opera");
    } else if (navigator.userAgent.indexOf("Edg") != -1) {
      formData.append("browser", "Edge");
    } else if (navigator.userAgent.indexOf("Chrome") != -1) {
      formData.append("browser", "Chrome");
    } else if (navigator.userAgent.indexOf("Safari") != -1) {
      formData.append("browser", "Safari");
    } else if (navigator.userAgent.indexOf("Firefox") != -1) {
      formData.append("browser", "Firefox");
    } else if (
      navigator.userAgent.indexOf("MSIE") != -1 ||
      !!document.documentMode == true
    ) {
      //IF IE > 10
      formData.append("browser", "IE");
    }
    formData.append("ip", ipAddress);
    console.log(formData);
    dispatch(updateRedux({ key: "submitLoader", value: true }));
    addToDisabled("submitButton");
    dispatch(
      insertIncident(formData, () => {
        dispatch(updateRedux({ key: "submitLoader", value: false }));
        removeFromDisabled("submitButton");
        setStage(5);
        setInputs({
          first_name: "",
          last_name: "",
          email: "",
          phone_number: "",
          files: [],
          country_code: "+971",
          incident_type: "",
          entity: "",
          date: "",
          reported_elsewhere: "",
          description: "",
          agree_conditions: false,
        });
        setLoader(false);
        dispatch(updateRedux({ key: "verify_status", value: false }));
        dispatch(updateRedux({ key: "hide_send_otp", value: false }));
        dispatch(updateRedux({ key: "otp_loader", value: false }));
        dispatch(updateRedux({ key: "ip_address", value: "" }));
      })
    );
  };

  const fileViewHandler = (file) => {
    setFileView(file);
    setModalShow(true);
  };

  const handleClose = () => {
    setModalShow(false);
    setFileView(null);
  };

  const renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {props.label}
    </Tooltip>
  );

  return (
    <div className="Page4 container">
      <Modal
        show={modalshow}
        centered
        onHide={handleClose}
        className="removeModfal preview-modal"
      >
        <Modal.Body>
          {fileView != null ? (
            <div>
              {fileView?.type === "image/jpeg" ||
                fileView?.type === "image/jpg" ||
                fileView?.type === "image/webp" ||
                fileView?.type === "image/png" ? (
                <img
                  className="file"
                  src={URL.createObjectURL(fileView)}
                  alt=""
                />
              ) : fileView.type === "video/mp4" || fileView.type === "video/mov" || fileView.type === "video/quicktime" ? (
                <video
                  src={URL.createObjectURL(fileView)}
                  width="320"
                  height="240"
                  controls
                ></video>
              ) : null}
            </div>
          ) : null}
          <p className="file-name">{fileView?.name}</p>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-danger" onClick={handleClose}>
            {t("close")}
          </button>
        </Modal.Footer>
      </Modal>
      <section className="personal-info">
        <h3>{t("personal_information")}</h3>
        <div className="row1 mb-0">
          <div className="column">
            <div>
              <p className="title">{t("first_name")}</p>
              <p className="value">{inputs.first_name}</p>
            </div>
            <div>
              <p className="title">{t("last_name")}</p>
              <p className="value">{inputs.last_name}</p>
            </div>
          </div>
          <div className="column">
            <div>
              <p className="title">{t("email")}</p>
              <p className="value">{inputs.email}</p>
            </div>
            <div>
              <p className="title">{t("phone_no")}</p>
              <p className="value phone">{`${inputs.country_code} ${inputs.phone_number}`}</p>
            </div>
          </div>
          <div className="column">
            <div>
            <p className="title">{t("emirates_id")}</p> 
              <p className="value">{inputs.emirates_id}</p>
            </div> 
            {/* <div className="emirates_id_proof">
              <p className="title">{t("emirates_id_proof")}</p>
              {
                Array.from(inputs.emirates_id_proof||[]).map((file, i) => {
                  return (
                    <>
                      {file.type === "image/jpg" ||
                        file.type === "image/jpeg" ||
                        file.type === "image/webp" ||
                        file.type === "image/png" ? (
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltip({
                            label: file.name,
                          })}
                        >
                          <span className="file-container">
                            <img
                              className="file"
                              src={URL.createObjectURL(file)}
                              alt=""
                              onClick={() => fileViewHandler(file)}
                            />
                          </span>
                        </OverlayTrigger>
                      ) : file.type === "application/pdf" ? (
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltip({
                            label: file.name,
                          })}
                        >
                          <span className="file-container">
                            <a
                              href={`${URL.createObjectURL(file)}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <img
                                className="file"
                                src="./assets/img/icons/Group 11807.png"
                                alt=""
                              />
                            </a>
                          </span>
                        </OverlayTrigger>
                      ) : file.type === "video/mp4" || file.type === "video/mov" || file.type === "video/quicktime" ? (
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltip({
                            label: file.name,
                          })}
                        >
                          <span className="file-container">
                            <img
                              className="file"
                              src="./assets/img/icons/v1.png"
                              alt=""
                              onClick={() => fileViewHandler(file)}
                            />
                          </span>
                        </OverlayTrigger>
                      ) : null}
                    </>
                  );
                })
              }
            </div>  */}
          </div>
        </div>
      </section>
      <section className="incident-repo">
        <h3>{t("incident_report")}</h3>
        <div className="tab">
          <div className="row2">
            <div className="column">
              <div>
                <p>{t("incident_type")}</p>
                <p>
                  {/* {
                    incident_type_list?.filter(
                      (ele) => ele._id == inputs.incident_type
                    )[0]?.incident_type
                  } */}
                  {lang === "en"
                    ? inputs?.incident_type?.incident_type
                    : inputs?.incident_type?.incident_type_ar}
                </p>
                {/* <p>{inputs.incident_type}</p> */}
                {/* <p>Crimes related to the public office</p> */}
              </div>
              <div>
                <p>{t("date_of_incident")}</p>
                <p>
                  <span dir="ltr">
                    {inputs.date
                      ? moment(inputs.date).format("DD MMM YYYY")
                      : "-"}
                  </span>
                </p>
                {/* <p>11 May 2022</p> */}
              </div>
            </div>
            <div className="column">
              <div>
                <p>{t("name_of_entity")}</p>
                <p>{inputs.entity}</p>
              </div>
              <div>
                <p>{t("is_this_incident_reported_elsewhere?")}</p>
                <p>{inputs.reported_elsewhere == "Yes" ? t("yes") : t("no")}</p>
              </div>
            </div>
          </div>
          <div className="row3">
            <p>{t("description")}</p>
            <p className="desc_text">{inputs.description}</p>
          </div>
          <div className="row3">
            <p>{t("attachments")}</p>
            <div className="attachment-files">
              {inputs.files.length > 0 ? (
                inputs.files.map((file, i) => {
                  return (
                    <>
                      {file.type === "image/jpg" ||
                        file.type === "image/jpeg" ||
                        file.type === "image/webp" ||
                        file.type === "image/png" ? (
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltip({
                            label: file.name,
                          })}
                        >
                          <span className="file-container">
                            <img
                              className="file"
                              src={URL.createObjectURL(file)}
                              alt=""
                              onClick={() => fileViewHandler(file)}
                            />
                            {/* <p className='file-name'>{file.name}</p> */}
                          </span>
                        </OverlayTrigger>
                      ) : file.type === "application/pdf" ? (
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltip({
                            label: file.name,
                          })}
                        >
                          <span className="file-container">
                            <a
                              href={`${URL.createObjectURL(file)}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <img
                                className="file"
                                src="./assets/img/icons/Group 11807.png"
                                alt=""
                              />
                            </a>
                            {/* <p className='file-name'>{file.name}</p> */}
                          </span>
                        </OverlayTrigger>
                      ) : file.type === "video/mp4" || file.type === "video/mov" || file.type === "video/quicktime" ? (
                        <OverlayTrigger
                          placement="bottom"
                          delay={{ show: 250, hide: 400 }}
                          overlay={renderTooltip({
                            label: file.name,
                          })}
                        >
                          <span className="file-container">
                            <img
                              className="file"
                              src="./assets/img/icons/v1.png"
                              alt=""
                              onClick={() => fileViewHandler(file)}
                            />
                          </span>
                        </OverlayTrigger>
                      ) : null}
                    </>
                  );
                })
              ) : (
                <small>{t("No Attachments")}</small>
              )}
            </div>
          </div>
        </div>
      </section>
      <div className="confirmation">
        {/* <span> */}
        <input
          type="checkbox"
          name=""
          id="confirmation"
          checked={inputs.agree_confirmation}
          onChange={(e) =>
            setInputs((s) => ({ ...s, agree_confirmation: e.target.checked }))
          }
        />
        <label htmlFor="confirmation">
          {t("i_confirm_that_above_information_is_accurate")}
        </label>
        {/* </span> */}
      </div>
      <div className="buttons">
        {/* <div className="buttons-group"> */}
        <button
          className="next-button"
          onClick={() => {
            // setStage(3)
            navigate(`/${lang}/report_incident/incident_report`);
          }}
        >
          <img
            className="left arrow"
            src="./assets/img/icons/Icon awesome-arrow-right.svg"
            alt=""
          />
          {t("edit")}
        </button>
        <span className="d-flex gap-3">
          {loader && (
            <img className="right" src="./assets/img/icons/loader.svg" alt="" />
          )}
          <button
            className={
              "next-button" + (inputs.agree_confirmation ? "" : " disabled")
            }
            disabled={disableButtons?.includes("submitButton")}
            onClick={() => onSubmitHandler()}
          // disabled={!inputs.agree_confirmation || disableButtons?.includes("submitButton")}
          >
            {t("submit")}
            <img
              className="right"
              src="./assets/img/icons/Icon awesome-arrow-right.svg"
              alt=""
            />
            {/* {submitLoad ? (
              <div
                class="spinner-border spinner-border-sm text-light ml-3"
                role="status"
              >
                <span class="sr-only">Loading...</span>
              </div>
            ) : null} */}
          </button>
        </span>
        {/* </div> */}
      </div>
    </div>
  );
}
